"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var dataManager;
        (function (dataManager) {
            const DEBOUNCE_DELAY_MS = 750;
            const _requestQueue = new Set();
            let _debounceTimer = null;
            let _dataFetchUrl = appn.emptyString;
            let _getToken = null;
            function init(dataFetchUrl, getToken) {
                _dataFetchUrl = dataFetchUrl;
                _getToken = getToken || null;
            }
            dataManager.init = init;
            function bindEvents() {
                distill.eventBus.subscribe(appn.designerv2.EVENTS.DATA_REFRESH_REQUESTED, (payload) => {
                    if (!payload || !payload.componentId)
                        return;
                    _requestQueue.add(payload.componentId);
                    if (_debounceTimer)
                        clearTimeout(_debounceTimer);
                    _debounceTimer = window.setTimeout(processQueue, DEBOUNCE_DELAY_MS);
                });
                distill.eventBus.subscribeToPropertyUpdates(payload => {
                    const component = dashboards.designer.getComponent(payload.componentId);
                    if (!component)
                        return;
                    const definition = distill.componentManager.getDefinition(component.type);
                    if (!definition)
                        return;
                    const dataQueryPropNames = distill.componentManager.getDataQueryPropertyNames(definition);
                    if (dataQueryPropNames.includes(payload.propName))
                        distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, { componentId: payload.componentId });
                });
            }
            dataManager.bindEvents = bindEvents;
            function getCachedResult(cacheKey) {
                return distill.dataCache.get(appn.utils.normalizeIdentifier(cacheKey)) || null;
            }
            dataManager.getCachedResult = getCachedResult;
            const TABLE_WINDOW_SIZE = 500;
            const _tableWindows = new Map();
            function getTableWindowSize() {
                return TABLE_WINDOW_SIZE;
            }
            dataManager.getTableWindowSize = getTableWindowSize;
            function getTableWindowOffset(componentId) {
                return _tableWindows.get(componentId) || 0;
            }
            dataManager.getTableWindowOffset = getTableWindowOffset;
            function hasTableWindow(componentId) {
                return _tableWindows.has(componentId);
            }
            dataManager.hasTableWindow = hasTableWindow;
            function setTableWindowOffset(componentId, offset) {
                _tableWindows.set(componentId, Math.max(0, offset));
            }
            dataManager.setTableWindowOffset = setTableWindowOffset;
            function resetTableWindows() {
                Array.from(_tableWindows.keys()).forEach(componentId => _tableWindows.set(componentId, 0));
            }
            dataManager.resetTableWindows = resetTableWindows;
            function getTableWindows() {
                return Array.from(_tableWindows.keys()).map(componentId => ({
                    componentId: componentId,
                    offset: _tableWindows.get(componentId) || 0,
                    limit: TABLE_WINDOW_SIZE
                }));
            }
            dataManager.getTableWindows = getTableWindows;
            function fetchFilterOptions(component, column, filters, search = '', values = null) {
                return __awaiter(this, void 0, void 0, function* () {
                    const token = _getToken ? yield _getToken() : null;
                    if (!token)
                        return null;
                    try {
                        const optionsUrl = _dataFetchUrl.replace('/dash/data', '/dash/filter-options');
                        const response = yield fetch(optionsUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                accessToken: token,
                                componentId: component.id,
                                column: column,
                                filters: filters,
                                search: search,
                                values: values || undefined
                            })
                        });
                        if (!response.ok)
                            return null;
                        const result = yield response.json();
                        if (!result || !result.Options)
                            return { options: [], available: null };
                        return {
                            options: result.Options.map((o) => ({ value: o.Value, count: o.Count || 0 })),
                            available: result.Available ? result.Available.map((o) => ({ value: o.Value, count: o.Count || 0 })) : null
                        };
                    }
                    catch (err) {
                        console.error('Error fetching filter options for ' + column, err);
                        return null;
                    }
                });
            }
            dataManager.fetchFilterOptions = fetchFilterOptions;
            function isDataQuerySufficient(componentType, dataQuery) {
                var _a, _b, _c, _d, _e;
                if (!dataQuery || !((_a = dataQuery.primaryDataset) === null || _a === void 0 ? void 0 : _a.id))
                    return false;
                const hasGroupBy = !!((_c = (_b = dataQuery.aggregation) === null || _b === void 0 ? void 0 : _b.groupBy) === null || _c === void 0 ? void 0 : _c.columnId);
                const hasMetrics = !!(((_d = dataQuery.aggregation) === null || _d === void 0 ? void 0 : _d.metrics) && dataQuery.aggregation.metrics.length > 0 && (dataQuery.aggregation.metrics[0].columnId || dataQuery.aggregation.metrics[0].function === 'Count'));
                const hasValidAggregation = hasGroupBy && hasMetrics;
                const hasValidProjection = !!(((_e = dataQuery.projection) === null || _e === void 0 ? void 0 : _e.columns) && dataQuery.projection.columns.length > 0 && dataQuery.projection.columns[0].columnId);
                if (componentType == dashboards.ComponentType.table && hasGroupBy)
                    return true;
                return hasValidAggregation || hasValidProjection;
            }
            function processQueue() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (_requestQueue.size === 0)
                        return;
                    const componentIds = Array.from(_requestQueue);
                    _requestQueue.clear();
                    const dataQueriesForRequest = [];
                    for (const id of componentIds) {
                        const component = dashboards.designer.getComponent(id);
                        if (!component)
                            continue;
                        const definition = distill.componentManager.getDefinition(component.type);
                        if (!definition)
                            continue;
                        for (const propName in definition.properties) {
                            const propDef = definition.properties[propName];
                            if (propDef.type === 'datasetSelector' && propDef.path) {
                                const dataQueryPropName = propDef.path.split('.')[0];
                                const dataQuery = component[dataQueryPropName];
                                if (dataQuery && isDataQuerySufficient(component.type, dataQuery)) {
                                    const dataQueryForRequest = appn.utils.deepClone(dataQuery);
                                    dataQueryForRequest.name = `${id}.${dataQueryPropName}`;
                                    if (component.type === dashboards.ComponentType.table && !dataQueryForRequest.limit)
                                        dataQueryForRequest.limit = TABLE_WINDOW_SIZE;
                                    dataQueriesForRequest.push(dataQueryForRequest);
                                }
                            }
                        }
                    }
                    if (dataQueriesForRequest.length === 0)
                        return;
                    console.log(`Fetching data for ${dataQueriesForRequest.map(d => d.name).join(', ')}`, dataQueriesForRequest);
                    try {
                        const response = yield fetch(_dataFetchUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ dashDataQueries: dataQueriesForRequest })
                        });
                        if (!response.ok)
                            throw new Error(`HTTP error! status: ${response.status}`);
                        const result = yield response.json();
                        if (result.Error)
                            throw new Error(`Query result error! Message: ${result.Error}`);
                        console.log(`Response for ${dataQueriesForRequest.map(d => d.name).join(', ')} received`, result);
                        distill.eventBus.publish(distill.EVENTS.DATA_FETCH_SUCCESS, result);
                    }
                    catch (error) {
                        console.error("Failed to fetch dashboard data:", error);
                    }
                });
            }
        })(dataManager = dashboards.dataManager || (dashboards.dataManager = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
